import { toast } from "react-toastify";

export const AKFA_PAGE_SIZE = 20;

export const SELECT_CLASS =
    "border w-[200px] border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500";

export const formatDateTime = (value) => (value ? new Date(value).toLocaleString() : "—");

export const formatDate = (value) => (value ? new Date(value).toLocaleDateString() : "—");

export const formatPrice = (price, currency) =>
    price === null || price === undefined ? "—" : `${price} ${currency || ""}`.trim();

// HubPageResponse: { data, total, page, size }
export const toPageState = (response, size) => ({
    items: response?.data || [],
    total: response?.total || 0,
    pageCount: Math.ceil((response?.total || 0) / (response?.size || size)),
});

export const showError = (response, fallback) =>
    toast.error(response?.message || fallback, { position: "bottom-right" });

export const showSuccess = (message) => toast.success(message, { position: "bottom-right", autoClose: 3000 });

export const downloadBlob = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
